import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import type { ServicePanelBaseProps } from "../shared";
import { DeleteService } from "./delete-service";

export function ServiceSettingsGeneral({ serviceId }: ServicePanelBaseProps) {
	/** Render */
	return (
		<ContentCard
			title="Danger Zone"
			icon={icon("Skull")}
		>
			<DeleteService serviceId={serviceId} />
		</ContentCard>
	);
}
